import React from 'react';
import { FilterOperators, getLabelForOperator } from '@opengov/reporting-types/src/reportFilters';
import { Input } from '../Input';
import { textFilterInputDataAttribute } from './DataAttributes';
export var FilterTextMultiFilterInput = function FilterTextMultiFilterInput(_ref) {
  var disabled = _ref.disabled,
      filterString = _ref.filterString,
      onChange = _ref.onChange,
      queryOperator = _ref.queryOperator;
  var commonProps = {
    dataTest: textFilterInputDataAttribute
  };
  var InputComponent = Input.Text.Small;

  switch (queryOperator) {
    case FilterOperators.Begin:
    case FilterOperators.End:
    case FilterOperators.Contain:
    case FilterOperators.NotContain:
    case FilterOperators.Equal:
    case FilterOperators.NotEqual:
      return React.createElement(InputComponent, Object.assign({}, commonProps, {
        disabled: disabled,
        onChange: onChange,
        placeholder: getLabelForOperator(queryOperator),
        value: filterString
      }));

    case FilterOperators.Blank:
      return React.createElement(InputComponent, Object.assign({}, commonProps, {
        disabled: true,
        value: 'Empty'
      }));

    case FilterOperators.NotBlank:
      return React.createElement(InputComponent, Object.assign({}, commonProps, {
        disabled: true,
        value: 'Not empty'
      }));

    default:
      return React.createElement(InputComponent, Object.assign({}, commonProps, {
        disabled: disabled,
        onChange: onChange,
        value: filterString
      }));
  }
};